import Axios from "axios";

const domain = "https://asia-southeast1-myprestasi-f6daa.cloudfunctions.net";
// const domain = "http://127.0.0.1:5001/myprestasi-f6daa/asia-southeast1";

// Configure axios for large file uploads
Axios.defaults.timeout = 540000; // 540 seconds (9 minutes)
Axios.defaults.maxContentLength = 100 * 1024 * 1024; // 100MB
Axios.defaults.maxBodyLength = 100 * 1024 * 1024; // 100MB

export const Get = (url, response, error, load) => {
  load(true);
  return Axios.get(`${domain}${url}`)
    .then((res) => {
      if (res.status !== 200) {
        error(res.data.message);
      } else response(res);
      load(false);
    })
    .catch((err) => {
      error(err ? err.message : "Unexpected Error");
      load(false);
    });
};

export const Post = (url, data, response, error, load) => {
  load(true);
  return Axios.post(`${domain}${url}`, data)
    .then((res) => {
      if (res.status !== 200) {
        error(res.data.message);
      } else response(res);
      load(false);
    })
    .catch((err) => {
      error(err ? err.message : "Unexpected Error");
      load(false);
    });
};

export const Delete = (url, response, error, load) => {
  load(true);
  return Axios.delete(`${domain}${url}`)
    .then((res) => {
      if (res.status !== 200) {
        error(res.data.message);
      } else response(res);
      load(false);
    })
    .catch((err) => {
      error(err ? err.message : "Unexpected Error");
      load(false);
    });
};
